<!-- HERO -->
<div class="hero-wrapper">
  <div class="hero-text">

    <h1 class="👻">Portrait Fashion Beatuy Fotograf Photograph Hamburg Kostenlost TFP 🙌</h1>
    <a [attr.href]="appService.instaLink" target="_blank" title="Lucas Bauche – Instagram">
      <picture loading="lazy">
        <img src="./assets/images/hero-text.svg" alt="Portrait Fotograf aus Hamburg">
      </picture>
    </a>
  </div>
</div>

<div class="page">

  <!-- GALLERY MOSAIC -->
  <div class="section">
    <h2 class="mb--m mt--xs">Portfolio Peek</h2>
    <app-gallery
      [leftCol]="[
        ['/assets/gallery/1.jpg', '/assets/gallery/13.jpg'],
        ['/assets/gallery/3.jpg'],
        ['/assets/gallery/5.jpg', '/assets/gallery/4.jpg', '/assets/gallery/14.jpg']
      ]"
      [rightCol]="[
        ['/assets/gallery/7.jpg'],
        ['/assets/gallery/9.jpg', '/assets/gallery/8.jpg'],
        ['/assets/gallery/10.jpg', '/assets/gallery/11.jpg', '/assets/gallery/12.jpg']
      ]"
    ></app-gallery>
  </div>

  <!-- ME -->
  <div class="section">
    <h2 class="mb--m mt--xs">About Me</h2>

    <div class="me-wrapper split">
      <div class="split-1 txt--center">
        <!-- <picture loading="lazy">
          <img src="./assets/images/me-2.svg" alt="It's me – Lucas">
        </picture>
      </div> -->
      <div class="split-1 txt--body p--m">
        <p>
          Ich bin Porträt Photograph aus Hamburg und shoote sowohl mit natürlichem Licht als auch im Studio.
        </p>
        <p>
          Seit 2024 fotografiere ich vorwiegend mit dem Leica M-System.
        </p>
        <p>
          Bin offen für Shootings und Kooperationen. Für eigene Art-Shootings auch gerne TFP.
        </p>
        <p>
          Neben der Fotografie bin ich Gründer und Investor in verschiedenen Software-Unternehmen.
        </p>
      </div>
    </div>
  </div>


  <!-- CTA -->
  <div class="section cta-bg">

    <div class="cta">
      <button class="button purple" (click)="cpaClicked()">
        Shooting anfragen
      </button>
    </div>
  </div>

</div>
